import Styles from './CtaBanner.module.css'

import type {Cta} from '../../../Index.types'

export interface CtaBannerProps {
  title: string
  cta: Cta
}

export const defaultProps: Partial<CtaBannerProps> = {}

export const CtaBanner = (props: CtaBannerProps) => {
  const initializedProps: CtaBannerProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['CtaBanner']}>CtaBanner</div>
}
